import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListAgent from "../Agent/listAgent";
import ListTimeSlot from "../Agent/listTimeSlot";
import "./headerAgent.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "agent_header_tab";

const HeaderAgent = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "agent"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "agent" ? "clicked" : ""}
              onClick={() => handleTableSelection("agent")}
            >
              Agent List
            </h4>

            <h4
              className={selectedTable === "time_slot" ? "clicked" : ""}
              onClick={() => handleTableSelection("time_slot")}
            >
              Agent Time Slot
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "agent" ? "block" : "none" }}>
            <ListAgent />
          </div>

          <div style={{ display: selectedTable === "time_slot" ? "block" : "none" }}>
            <ListTimeSlot />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderAgent;
